import { gql } from "@apollo/client";
import { System } from "./getSystemCall";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const MAINTAIN_SYSTEM_INFO = gql`
  mutation MaintainSystem($domain: String!, $system: MaintainSystemInput!) {
    system {
      maintain(domain: $domain, system: $system) {
        code
        success
        message
        updatedValues {
          system_id
          fk_system_types
          name
          default_amount
          min_feed_speed
          max_feed_speed
          programmed
        }
      }
    }
  }
`

export interface MaintainSystemInput {
  system_id: number;
  name?: string; 
  feed_balance?: number;
  feed_balance_unit?: number;
  default_amount?: number;
  min_feed_speed?: number;
  max_feed_speed?: number;
  programmed?: number;
}

interface SystemMutationResponse extends Def_MutationResponse {
  updatedValues?: [System]
}

export interface MaintainSystemResponse {
  system: {
    maintain: SystemMutationResponse;
  }
}

export const MAINTAIN_SYSTEM_IMAGE = gql`
  mutation MaintainSystemImage($domain: String!, $systemId: Int!, $image: String) {
    system {
      image(domain: $domain, systemId: $systemId, image: $image) {
        code
        success
        message
        updatedValues {
          system_id
          fk_system_types
          name
          feed_balance
          feed_balance_unit
          default_amount
          min_feed_speed
          max_feed_speed
          programmed
          image
        }
      }
    }
  }
`

export interface MaintainSystemImageResponse {
  system: {
    image: SystemMutationResponse;
  }
}
